module.exports = __webpack_public_path__ + "img/nav-theme-light.e765f4e4.svg";